import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element that displays a variant-aware product title.
 * Listens for variant update events and updates the title from the re-rendered section HTML.
 *
 * @extends {Component}
 */
class ProductVariantTitle extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateTitle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateTitle);
  }

  /**
   * Updates the title from the re-rendered section HTML.
   * @param {CustomEvent} event - The variant update event.
   */
  updateTitle = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `product-variant-title[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    const newTitle = newElement.querySelector('.product-variant-title');
    const currentTitle = this.querySelector('.product-variant-title');
    if (newTitle && currentTitle) {
      currentTitle.textContent = newTitle.textContent;
    }
  };
}

if (!customElements.get('product-variant-title')) {
  customElements.define('product-variant-title', ProductVariantTitle);
}
